// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Config$LiveRoom from "../Config.bs.js";
import * as Utils_Web$LiveRoom from "./Utils/Utils_Web.bs.js";

function buildQueryString(linkQueryString, keys) {
  var existingParams = Belt_Array.keep(Utils_Web$LiveRoom.getCurrentParams(undefined), (function (param) {
          var key = param[0];
          return keys.some(function (k) {
                      return k === key;
                    });
        }));
  var linkParams = Array.from(new URLSearchParams(linkQueryString).entries());
  var combined = new URLSearchParams(Belt_Array.concat(existingParams, linkParams)).toString();
  if (combined === "") {
    return "";
  } else {
    return "?" + decodeURIComponent(combined) + "";
  }
}

function Link$AuctionDetailPage(props) {
  var inNewTab = props.inNewTab;
  var inNewTab$1 = inNewTab !== undefined ? inNewTab : false;
  var fullUrl = Config$LiveRoom.values.bidclientUrl + props.auctionUrl;
  var url = Config$LiveRoom.values.bidclientUrl + new URL(fullUrl).pathname;
  return React.createElement("a", {
              className: props.className,
              href: url + buildQueryString(new URL(fullUrl).searchParams.toString(), [
                    "sessionId",
                    "previewToken",
                    "locale"
                  ]),
              target: inNewTab$1 ? "_blank" : "_self"
            }, props.children);
}

var AuctionDetailPage = {
  make: Link$AuctionDetailPage
};

export {
  buildQueryString ,
  AuctionDetailPage ,
}
/* react Not a pure module */
